import React from 'react';
import styled from 'styled-components';
import * as BuilderInfoUI from '../../BuilderInfoUI';

interface IProps {
  formula: string;
}

const Container = styled(BuilderInfoUI.VerticalRow)`
  align-items: start;
`;
const FormulaWrapper = styled(BuilderInfoUI.BorderedInfo)`
  min-width: 100px;
  margin-right: 0;
`;

const MeasureFormulaInfo = ({ formula }: IProps) => {
  return (
    <Container>
      <BuilderInfoUI.HighlightedLabel>Formula</BuilderInfoUI.HighlightedLabel>
      <FormulaWrapper>{formula}</FormulaWrapper>
    </Container>
  );
};

export default MeasureFormulaInfo;
